import type { PortalCartDto } from '@supply-mover-2-0/shared';
import { create } from 'zustand';

interface CartState {
	/** The full cart DTO from the API, or null if no cart exists */
	cart: PortalCartDto | null;
	isLoading: boolean;
	/**
	 * Total UNITS in the cart (sum of every line's quantityOrdered), not the
	 * number of lines (PD-13692). Promo/BXGY phantom lines are counted too, so
	 * a buy-1-get-1 reads as 2 — the customer sees the bonus unit.
	 */
	totalQuantity: number;

	setCart: (cart: PortalCartDto | null) => void;
	setLoading: (value: boolean) => void;
	clear: () => void;
}

export const useCartStore = create<CartState>((set) => ({
	cart: null,
	isLoading: false,
	totalQuantity: 0,

	setCart: (cart) =>
		set({
			cart,
			totalQuantity:
				cart?.lineItems.reduce((sum, li) => sum + li.quantityOrdered, 0) ?? 0,
		}),

	setLoading: (value) => set({ isLoading: value }),

	clear: () => set({ cart: null, totalQuantity: 0 }),
}));
